import { createElement, ReactNode } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';

import cn from './Screen.css.json';
import './Screen.css';

export interface ScreenProps {
  children?: ReactNode;
  isActive: boolean;
}

export const Screen = ({ isActive, children }: ScreenProps) => {
  const dt = useDesignTokens();
  const tokens = renderInlineCssVars({ 'spacing-l': dt.spacing.core.l }, 'screen');

  return (
    <div className={cn.wrapper} style={{ ...tokens, display: isActive ? 'block' : 'none' }}>
      {children}
    </div>
  );
};
